// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".formValidate[data-v-4ec4b937] {\n  padding: 0 20px;\n}\n.mt20[data-v-4ec4b937] {\n  margin-top: 20px;\n}\n.from-tips[data-v-4ec4b937] {\n  font-size: 12px;\n  color: #999;\n  line-height: 1.5;\n  margin-top: 5px;\n}\n.invoice-items-table[data-v-4ec4b937] {\n  border: 1px solid #EBEEF5;\n  border-radius: 4px;\n  padding: 10px;\n  background: #fff;\n}\n.el-button--text[data-v-4ec4b937] {\n  padding: 0;\n}", ""]);
// Exports
module.exports = exports;
